import React from 'react';
import { Entry } from 'contentful';
import { HardCodedSection, HardCodedSectionType } from 'types/Content';
import FiveStarReviewsBlock from './FiveStarReviewsBlock';
import TutorCardsBlock from 'components/TutorCardsBlock';
import MetQualifiedSafeBlock from './MetQualifiedSafeBlock';
import SearchMessageDetailsLearnBlock from './SearchMessageDetailsLearnBlock';
import SubjectsWeOfferBlock from './SubjectsWeOfferBlock';
import TutoringFAQsBlock from './TutoringFAQsBlock';
import EducationThatWorksForEveryoneBlock from './EducationThatWorksForEveryoneBlock';
import TutorCruncherTutorSignupForm from './TutorCruncherTutorSignupForm';
import { useTranslation } from 'react-i18next';

export interface HardCodedProps {
  section: Entry<HardCodedSection>;
  subject?: string;
  level?: string;
}

export default function HardCodedBlock({
  section,
  level,
  subject
}: HardCodedProps) {
  const {
    FIVE_STAR_REVIEWS,
    TUTOR_CARDS,
    MET_QUALIFIED_SAFE,
    SEARCH_MESSAGE_DETAILS_LEARN,
    SUBJECTS_WE_OFFER,
    TUTORING_FAQS,
    EDUCATION_THAT_WORKS_FOR_EVERYONE,
    TUTORCRUNCHER_TUTOR_SIGNUP_FORM
  } = HardCodedSectionType;

  const sectionType = section.fields.sectionType as HardCodedSectionType;

  const { t } = useTranslation()

  switch (sectionType) {
    case FIVE_STAR_REVIEWS:
      return <FiveStarReviewsBlock />;
    case TUTOR_CARDS:
      return <TutorCardsBlock subject={subject} level={level} limit={2} />;
    case MET_QUALIFIED_SAFE:
      return <MetQualifiedSafeBlock />;
    case SEARCH_MESSAGE_DETAILS_LEARN:
      return <SearchMessageDetailsLearnBlock />;
    case SUBJECTS_WE_OFFER:
      return <SubjectsWeOfferBlock />;
    case TUTORING_FAQS:
      return <TutoringFAQsBlock />;
    case EDUCATION_THAT_WORKS_FOR_EVERYONE:
      return <EducationThatWorksForEveryoneBlock />;
    case TUTORCRUNCHER_TUTOR_SIGNUP_FORM:
      return <TutorCruncherTutorSignupForm />;
    default:
      return (
        <h1 style={{ backgroundColor: 'red', height: '40px' }}>
          {t('UNIMPLEMENTED')} {sectionType}
        </h1>
      );
  }
}
